import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import './blog-detail.scss';
import SEO from '../../seo/SEO';

const timingsData = [
  {
    id: 1,
    title: 'Morning Aarti (Atka Aarti)',
    time: '05:00 AM - 07:00 AM',
    highlight: true,
    timeColor: 'gold',
  },
  {
    id: 2,
    title: 'Holy Cave Darshan',
    time: 'Open 24 Hours (Except Aarti)',
    highlight: false,
    timeColor: 'teal',
  },
  {
    id: 3,
    title: 'Evening Aarti (Sandhya Aarti)',
    time: '06:00 PM - 08:00 PM',
    highlight: true,
    timeColor: 'gold',
  },
  {
    id: 4,
    title: 'Yatra Registration Counter (RFID)',
    time: '05:00 AM - 10:00 PM',
    highlight: false,
    timeColor: 'teal',
  },
  {
    id: 5,
    title: 'Bhairavnath Ropeway Service',
    time: '07:00 AM - 06:00 PM',
    highlight: false,
    timeColor: 'dark',
  },
];

const dossierData = [
  { key: 'Sacred Location', val: 'Trikuta Hills, Katra, Reasi District, Jammu & Kashmir' },
  { key: 'Altitude / Elevation', val: 'Approx. 5,200 ft (1,585 meters)' },
  { key: 'Presiding Deity', val: 'Mata Vaishno Devi (Self-manifested 3 Pindis)' },
  { key: 'Divine Manifestations', val: 'Maha Kali (Tamoguna), Maha Lakshmi (Rajoguna), Maha Saraswati (Sattvaguna)' },
  { key: 'Trek Distance', val: '12 km trek from Katra Base Camp (Baan Ganga)' },
  { key: 'Key Holy Stops', val: 'Baan Ganga, Charan Paduka, Ardhkuwari (Garbhjoon), Bhawan, Bhairavnath' },
  { key: 'Pilgrimage Window', val: 'Open throughout the year (365 Days, 24x7)' },
];

const sacredStopsList = [
  {
    id: 1,
    name: '1. Baan Ganga (Baal Ganga)',
    tag: 'Holy stream created by Mother with an arrow to quench Veer Hanuman’s thirst',
    image: '/assets/packages/vaishno-devi.webp',
  },
  {
    id: 2,
    name: '2. Charan Paduka Temple',
    tag: 'Sacred spot bearing immortal impressions of the Goddess’s divine feet',
    image: '/assets/vaishno-packages/package-1.webp',
  },
  {
    id: 3,
    name: '3. Ardhkuwari (Garbhjoon Cave)',
    tag: 'Mystical womb-like cave where Mata stayed in deep meditation for 9 months',
    image: '/assets/banner/vr-darshan/temples/vaishno-devi.webp',
  },
  {
    id: 4,
    name: '4. Holy Bhawan (Natural Cave)',
    tag: 'Sacred sanctum sanctorum housing the three self-manifested pindis',
    image: '/assets/banner/vaishno-package-banner.webp',
  },
  {
    id: 5,
    name: '5. Bhairavnath Temple',
    tag: 'Where Bhairavnath attained salvation; essential shrine completing the yatra',
    image: '/assets/trending/vaishno-devi.webp',
  },
];

const interestedBlogs = [
  {
    id: 1,
    title: 'पितृपक्ष में कौए को भोजन क्यों खिलाया जाता है? जानिए पौराणिक कथा और श्राद्ध पूजा विधि',
    image: '/assets/blog/pitru-paksha-crow-banner.jpg',
    link: '/blog/pitru-paksha-crow-significance-shradh-puja-vidhi',
  },
  {
    id: 2,
    title: 'केदारनाथ मंदिर: जहाँ धरती में समा गए थे भगवान शिव!',
    image: '/assets/blog/trending/kedarnath.webp',
    link: '/blog/kedarnath-temple-history-and-pandava-story',
  },
  {
    id: 3,
    title: 'Why is Ganesh Chaturthi celebrated? Rituals & History',
    image: '/assets/blog/ganesh-chaturthi-banner.webp',
    link: '/blog/anant-chaturdashi-ganesh-visarjan',
  },
];

export default function VaishnoDeviBlogDetail() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    document.title =
      'माता वैष्णो देवी की संपूर्ण कथा: भक्त श्रीधर और भैरवनाथ से जुड़ी अद्भुत कहानी | MandirWiki';
  }, [location.pathname]);

  return (
    <div className="blog-detail-page">
      {/* ========================================================
          1. HERO BANNER
      ======================================================== */}
      <section
        className="blog-detail-banner kedarnath-hero-banner"
        style={{
          backgroundImage: "url('/assets/banner/vaishno-package-banner.webp')",
          backgroundPosition: 'center center',
        }}
      >
        <Container maxWidth="lg" className="banner-container">
          <SEO pageKey="blogVaishnoDevi" />
          <Box className="banner-content" sx={{ maxWidth: { xs: '100%', md: '760px' } }}>
            <h1 className="banner-title" style={{ fontSize: 'clamp(24px, 2.7vw, 36px)', lineHeight: 1.35 }}>
              माता वैष्णो देवी की संपूर्ण कथा <br />
              <span style={{ fontSize: '0.85em', fontWeight: 600, opacity: 0.95 }}>
                भक्त श्रीधर और भैरवनाथ से जुड़ी अद्भुत कहानी
              </span>
            </h1>
          </Box>
        </Container>
      </section>

      {/* ========================================================
          2. MAIN CONTENT & SIDEBAR SECTION
      ======================================================== */}
      <section className="blog-body-section">
        <Container maxWidth="lg">
          <div className="blog-body-inner">
            {/* Breadcrumbs */}
            <nav className="blog-breadcrumbs" aria-label="breadcrumb">
              <Link to="/" className="breadcrumb-link">
                Home
              </Link>
              <span className="breadcrumb-separator">&gt;</span>
              <Link to="/blog" className="breadcrumb-link">
                Blog
              </Link>
              <span className="breadcrumb-separator">&gt;</span>
              <span className="breadcrumb-current">
                माता वैष्णो देवी की संपूर्ण कथा
              </span>
            </nav>

            {/* Two Column Grid */}
            <div className="blog-main-layout">
              {/* Left Column: Article Body */}
              <article className="blog-article-content">
                <p className="article-paragraph">
                  भारत की पवित्र धरती पर अनेक देवी देवताओं ने अधर्म पर धर्म की विजय प्राप्ति के लिए सदैव ही अलग–अलग रूपों में अवतार लिए हैं| ऐसा ही एक दिव्य अवतार है माता वैष्णो देवी का |
                </p>

                <p className="article-paragraph">
                  माता वैष्णो देवी के संसार भर में करोड़ों भक्त हैं| माता वैष्णो देवी मंदिर की महिमा पूरे जगत में प्रसिद्ध है| यही कारण है कि  माता के पवित्र दरबार में सदैव ही भक्तों की भीड़ लगी रहती है| माता वैष्णो देवी मंदिर की महिमा अपार है|
                </p>

                <p className="article-paragraph">
                  कहते हैं कि जो भी भक्त सच्चे मन से माता वैष्णो देवी के दर्शन करने उनके दरबार में आता है, माता वैष्णो देवी उसकी मनोकामना पूर्ण करती हैं और भक्त की खाली झोली खुशियों से भर देती हैं|
                </p>

                <p className="article-paragraph">
                  माता के चमत्कार से जुड़ी बहुत सी कथाएं धार्मिक ग्रंथों में मिलती हैं, जिनमें से भक्त श्रीधर की कथा बहुत ही प्रचलित है।
                </p>

                {/* Section 1 */}
                <h2 className="article-heading">
                  कौन थे भक्त श्रीधर? जानिए माता वैष्णो देवी से जुड़ी चमत्कारी कथा
                </h2>

                <p className="article-paragraph">
                  कौन थे भक्त श्रीधर? और वैष्णो माता ने उनका कैसे उद्धार किया था? आखिर क्यों भैरवनाथ मंदिर के दर्शन के बिना अधूरी है वैष्णो देवी की यात्रा। इन सब गूढ़ रहस्यों और माता के चमत्कार से जुड़ी है माता वैष्णो देवी मंदिर की ये अद्भुत कहानी–
                </p>

                {/* Inline Media Row */}
                <div className="article-media-row">
                  <div className="media-image-box">
                    <img
                      src="/assets/banner/vr-darshan/temples/vaishno-devi-main.webp"
                      alt="माता वैष्णो देवी और भक्त श्रीधर की चमत्कारी कथा"
                      className="media-image"
                      loading="lazy"
                    />
                  </div>
                  <div className="media-text-box">
                    <p className="article-paragraph">
                      जम्मू कटरा से दो किलोमीटर की दूरी पर हंसाली गांव में श्रीधर नाम के एक गरीब ब्राह्मण रहते थे। वे मां दुर्गा के परम भक्त थे। श्रीधर के कोई संतान नहीं थी, इसीलिए वे और उनकी पत्नी अक्सर बहुत दुखी रहते थे। वे कई वर्षों से मां दुर्गा के नवरात्रि व्रत और कन्या पूजन करते आ रहे थे, पर वो बहुत निराश थे, कि अभी तक मां दुर्गा ने उनकी मनोकामना पूरी नहीं की थी। इस बार भी श्रीधर और उनकी पत्नी सुलोचना ने सच्चे मन से मां दुर्गा के नवरात्रि व्रत रखे थे, पर इस बार श्रीधर ने सोच लिया था कि वो मां को मनाकर ही रहेगा। कहते हैं मां अपने बच्चों को कभी दुखी नहीं देख सकतीं, भक्त श्रीधर की पुकार सुनकर मां दुर्गा से रहा नहीं गया, और फिर जब अगले दिन श्रीधर और सुलोचना ने कन्या पूजन किया तो मां दुर्गा एक छोटी सी कन्या का रूप लेकर बाकी कन्याओं के बीच में आकर बैठ गईं। जब सब कन्याएं प्रसाद लेकर चली गईं, तब वह कन्या वहीं बैठी रही। उसने प्रसाद नहीं खाया था। श्रीधर बोले हे देवी कन्या क्या हुआ आपने प्रसाद क्यों नहीं खाया? तब कन्या बोली पंडित जी आपने भी तो कितने दिनों से कुछ नहीं खाया। जब तक आप नहीं खाओगे तब तक मैं भी कुछ नहीं खाऊंगी।
                    </p>
                  </div>
                </div>

                <p className="article-paragraph">
                  श्रीधर बोले हे देवी मैंने प्रण किया था कि जब तक देवी मां मुझे दर्शन नहीं देंगी, तब तक मैं कुछ नहीं खाऊंगा। तब वह कन्या मुस्कुराते हुए बोली, पंडित जी मैं भी तो उन्हीं का रूप हूं आप यह समझो कि मैं स्वयं मां दुर्गा हूं।
                </p>

                <p className="article-paragraph">
                  भक्त श्रीधर की आँखों में आंसू थे उन्होंने  हाथ जोड़कर देवी मां को याद किया और उस कन्या को भोजन खिलाया और खुद भी भोजन ग्रहण किया।
                </p>

                {/* Section 2 */}
                <h2 className="article-heading">
                  कन्या रूप में आईं माता वैष्णो देवी, भक्त श्रीधर को दिए दर्शन
                </h2>

                <p className="article-paragraph">
                  कन्या बोली, पंडित जी कल आप देवी मां के  नाम का भंडारा करो। पूरे गांव को भंडारे का निमंत्रण दो, और हां भंडारे में भैरवनाथ को बुलाना मत भूलना। कन्या की बात सुनकर श्रीधर पंडित जी थोड़े उदास हो गए, वह हाथ जोड़कर उस कन्या से बोले, हे दिव्य कन्या मुझमें इतना सामर्थ्य नहीं कि मैं पूरे गांव का भंडारा कर सकूं। तब कन्या मुस्कुराते हुए बोली पंडित जी आपको अपनी देवी मां पर विश्वास है ना, तो उनके ऊपर पूर्ण विश्वास के साथ आप यह कार्य करो और बाकी सब देवी मां पर छोड़ दो।
                </p>

                <p className="article-paragraph">
                  लोगों ने निमंत्रण स्वीकार कर लिया, दिव्य कन्या के कहे अनुसार श्रीधर ने गुरु भैरवनाथ को भी भंडारे का निमंत्रण दिया।
                </p>

                <p className="article-paragraph">
                  अगले दिन गांव के सभी लोग धीरे-धीरे करके श्रीधर के घर भंडारे के लिए पहुंचने लगे। मां दुर्गा उस कन्या के रूप में वहां आती हैं, और उनके चमत्कार से भंडारे की सारी व्यवस्था हो जाती है। सब जयकारा लगाते हैं। भैरवनाथ अपने स्वभाव के अनुसार मांसाहारी भोजन और मदिरा मांगता है। पर कन्या के रूप में मां दुर्गा उसे यह सब देने के लिए मना करती हैं। भैरवनाथ उनसे उनका परिचय मांगता है, और उनका हाथ पकड़ लेता है। तभी मां दुर्गा वहां से अंतर्धान हो जाती हैं, वह श्रीधर के घर अपने चरण छोड़ देती हैं।
                </p>

                <p className="article-paragraph">
                  भैरवनाथ मां दुर्गा के पीछे-पीछे जाता है
                </p>

                {/* Section 3 & Full Banner */}
                <div className="blog-full-grid-section">
                  <div className="article-full-banner">
                    <img
                      src="/assets/packages/vaishno-devi.webp"
                      alt="अर्धकुंवारी गुफा, चरण पादुका, बाण गंगा और पवित्र भवन"
                      className="full-banner-img"
                      loading="lazy"
                    />
                  </div>

                  <div className="full-grid-content">
                    <h2 className="article-heading">
                      अर्धकुंवारी गुफा, चरण पादुका और बाण गंगा का रहस्य
                    </h2>

                    <p className="article-paragraph">
                      रास्ते में वीर हनुमान मां दुर्गा की सेवा में आते हैं। मां दुर्गा वीर हनुमान को भैरवनाथ को रोकने की आज्ञा देती हैं।
                    </p>

                    <p className="article-paragraph">
                      वीर हनुमान को प्यास लगी थी, मां दुर्गा ने अपने बाण से वहां जल की धारा प्रकट की कहते हैं यही धारा “बाण गंगा” कहलाई।
                    </p>

                    <p className="article-paragraph">
                      इस जल से मैया ने अपने केश भी धोए थे इसलिए इस गंगा को “बाल गंगा” भी कहते हैं।
                    </p>

                    <p className="article-paragraph">
                      मां ने जहां से पीछे मुड़कर भैरवनाथ को देखा था, उस स्थान को “चरण पादुका” कहते हैं।
                    </p>

                    <p className="article-paragraph">
                      इसके पश्चात देवी दुर्गा गर्भ गुफा में विश्राम के लिए चली जाती हैं, तथा वहां नौ मास तक रहती हैं। वह जगह “अर्धकुंवारी” के रूप में प्रसिद्ध है। अर्धकुंवारी स्थित गुफा को "गर्भजून" (या गर्भजून गुफा) के नाम से जाना जाता है।
                    </p>

                    {/* Section 4 */}
                    <h2 className="article-heading">
                      भैरवनाथ मंदिर के दर्शन के बिना अधूरी क्यों है वैष्णो देवी यात्रा?
                    </h2>

                    <p className="article-paragraph">
                      अंत समय में भैरवनाथ ने मां दुर्गा से क्षमा मांगी, तब देवी शक्ति ने भैरवनाथ को वरदान दिया, कि वैष्णो देवी की यात्रा तभी पूर्ण मानी जाएगी जब भक्त भैरवनाथ मंदिर के दर्शन करेंगे।
                    </p>

                    <p className="article-paragraph">
                      वैष्णो माता की कृपा से श्रीधर और सुलोचना को संतान का सुख प्राप्त हुआ। इसके पश्चात माता की आज्ञा से भक्त श्रीधर ने अपना संपूर्ण जीवन उनकी सेवा और भक्ति में लगा दिया।
                    </p>

                    <p className="article-paragraph">
                      धीरे-धीरे माता की महिमा चारों ओर फैलने लगी और माता का यह पवित्र धाम माता वैष्णो देवी के नाम से विख्यात हो गया।
                    </p>

                    {/* Section 5 */}
                    <h2 className="article-heading">
                      माता वैष्णो देवी की पवित्र गुफा में विराजमान हैं तीन पिंडियां
                    </h2>

                    <p className="article-paragraph">
                      पवित्र गुफा में माता के तीन प्राकृतिक पिंडी स्वरूप मां महाकाली, मां महालक्ष्मी और मां महासरस्वती के रूप में पूजे जाते हैं।
                    </p>

                    <p className="article-paragraph">
                      कहते हैं, जो भी भक्त सच्ची आस्था से माता वैष्णों देवी के मंदिर दर्शन के लिए आते हैं, उन भक्तों पर माता वैष्णो की कृपा सदैव बनी रहती है और भक्तों का जीवन खुशियों से भरा रहता है।
                    </p>
                  </div>
                </div>
              </article>

              {/* Right Column: Sidebar Cards (Sticky) */}
              <aside className="blog-sidebar">
                {/* Card 1: Darshan & Aarti Timings */}
                <div className="muhurat-widget-card">
                  <div className="muhurat-header">
                    <div className="muhurat-header-title">
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="clock-icon"
                      >
                        <circle cx="12" cy="12" r="10" />
                        <polyline points="12 6 12 12 16 14" />
                      </svg>
                      <span>Darshan &amp; Aarti Timings</span>
                    </div>

                    <span className="muhurat-pill-badge">
                      <span className="dot" />
                      Mata Vaishno Devi &bull; Katra
                    </span>
                  </div>

                  <div className="muhurat-body">
                    <div className="visarjan-day-meta">
                      Sacred Darshan: <strong>Holy Bhawan Open 24 Hours</strong>
                    </div>

                    <div className="timings-list">
                      {timingsData.map((item) => (
                        <div
                          key={item.id}
                          className={`timing-row ${item.highlight ? 'highlight-gold' : ''}`}
                        >
                          <span className="timing-label">{item.title}</span>
                          <span className={`timing-val color-${item.timeColor}`}>
                            {item.time}
                          </span>
                        </div>
                      ))}
                    </div>

                    <Link to="/vaishno-devi-package" style={{ textDecoration: 'none' }}>
                      <button type="button" className="book-puja-btn">
                        BOOK VAISHNO DEVI YATRA PACKAGE
                      </button>
                    </Link>

                    <p className="instant-booking-note">
                      VIP Darshan, Yatra RFID Parchi &amp; Helicopter Assistance
                    </p>
                  </div>
                </div>

                {/* Card 2: Quick Dossier */}
                <div className="sidebar-card dossier-card">
                  <div className="sidebar-card-header">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="header-icon"
                    >
                      <path d="M3 21h18M3 10h18M5 10v11M19 10v11M9 10v11M15 10v11M12 2l10 8H2l10-8z" />
                    </svg>
                    <h3 className="card-title">Mata Vaishno Devi Dossier</h3>
                  </div>

                  <div className="dossier-table">
                    {dossierData.map((row, idx) => (
                      <div key={idx} className="dossier-row">
                        <span className="dossier-key">{row.key}</span>
                        <span className="dossier-val">{row.val}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Card 3: Sacred Yatra Stops */}
                <div className="sidebar-card ghats-card">
                  <div className="sidebar-card-header">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="header-icon"
                    >
                      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                      <polyline points="22 4 12 14.01 9 11.01" />
                    </svg>
                    <h3 className="card-title">Sacred Yatra Shrines</h3>
                  </div>

                  <div className="ghats-list">
                    {sacredStopsList.map((item) => (
                      <div key={item.id} className="ghat-item">
                        <img src={item.image} alt={item.name} className="ghat-thumb" />
                        <div className="ghat-info">
                          <h4 className="ghat-name">{item.name}</h4>
                          <span className="ghat-tag">{item.tag}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Card 4: Free Offline Yatra Guide (PDF) */}
                <div className="sidebar-card pdf-card">
                  <div className="sidebar-card-header">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="header-icon"
                    >
                      <circle cx="12" cy="12" r="10" />
                      <path d="M8 12l4 4 4-4m-4-4v8" />
                    </svg>
                    <h3 className="card-title">Free Offline Yatra Guide (PDF)</h3>
                  </div>

                  <p className="pdf-desc">
                    Get full route map from Katra, helicopter booking rules, ropeway timings, battery car info, and sacred stopovers in one offline PDF.
                  </p>

                  <a
                    href="/assets/startup-india-certificate.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none', display: 'block' }}
                  >
                    <button type="button" className="download-pdf-btn">
                      DOWNLOAD PDF (2.8 MB)
                    </button>
                  </a>
                </div>
              </aside>
            </div>
          </div>
        </Container>
      </section>

      {/* ========================================================
          3. YOU MIGHT ALSO BE INTERESTED IN THIS
      ======================================================== */}
      <section className="blog-interested-section pt-0">
        <Container maxWidth="lg">
          <h2 className="interested-heading">
            You Might Also Be Interested In This
          </h2>
          <div className="interested-grid">
            {interestedBlogs.map((item) => (
              <Link
                key={item.id}
                to={item.link}
                className="interested-card"
              >
                <div className="card-thumb-wrap">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="card-thumb"
                    loading="lazy"
                  />
                </div>
                <div className="card-content">
                  <h3 className="card-title">{item.title}</h3>
                </div>
              </Link>
            ))}
          </div>
        </Container>
      </section>
    </div>
  );
}
